import React from "react";
import * as S from "./PopUp1Style";
import GoldenMiniLogo from "../GoldenMiniLogo/GoldenMiniLogo";

const POPUP1_SESSION_KEY = "popup1Seen";

export default function PopUp1({ onClose }) {
  const handleWhatsAppClick = () => {
    const phone = "5547988192616";
    const text =
      "Olá! Quero saber mais sobre a proposta para ganhar mais dinheiro com a Golden Brasil.";
    window.open(
      `https://wa.me/${phone}?text=${encodeURIComponent(text)}`,
      "_blank"
    );
  };

  const handleClose = () => {
    sessionStorage.setItem(POPUP1_SESSION_KEY, "true");
    onClose();
  };

  return (
    <S.Overlay onClick={handleClose}>
      <S.Container onClick={(e) => e.stopPropagation()}>
        <S.LogoBox>
          <S.BrandWrapper>
            <GoldenMiniLogo />
          </S.BrandWrapper>
        </S.LogoBox>

        <S.Header>
          <S.Badge>PROPOSTA EXCLUSIVA</S.Badge>
          <S.Title>TEMOS ALGO PARA VOCÊ!</S.Title>
        </S.Header>

        <S.TextContent>
          <p>
            Temos uma <strong>excelente proposta</strong> para você{" "}
            <strong>ganhar mais dinheiro.</strong> Quer saber?
          </p>
          <p className="footer-text">
            Chame já nossos consultores ou na central{" "}
            <strong>0800 042 0938</strong>
          </p>
        </S.TextContent>

        <S.ButtonContainer>
          <S.AcceptButton onClick={handleWhatsAppClick}>
            Falar com um consultor agora
          </S.AcceptButton>
          <S.CloseButton onClick={handleClose}>Talvez outro dia</S.CloseButton>
        </S.ButtonContainer>
      </S.Container>
    </S.Overlay>
  );
}

export { POPUP1_SESSION_KEY };
